import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

const MapContainer = styled.div`
  position: relative;

  .gm-style-iw {
    padding: 5px !important;

    .info-window-image {
    }

    .info-window-text {
      max-width: 120px;
      max-height: 60px;
      min-height: 20px;
      display: flex;
      align-items: center;
    }

    .gm-style-iw-d {
      overflow: auto !important;
    }
  }

  .advanced-marker {
    position: relative;
    background-color: white;
    border-radius: 4px;
    padding: 5px;

    img {
      max-width: 120px;
      max-height: 60px;
    }

    :after {
      position: absolute;
      content: '';
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      bottom: -10px;
      left: 0;
      right: 0;
      margin: auto;

      border-top: 10px solid white;
    }
  }

  .google-map-marker {
    background-color: ${({ theme }) => theme.background};
    height: 34px;
    width: 65px;
    padding: 4px;
    border-radius: 4px;
    position: relative;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.textDark};
    box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.1);

    .google-marker-agent-logo {
      width: 36px;
      height: 36px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    p {
      text-align: center;
      font-size: 14px;
      font-weight: 700;
    }

    img {
      width: 16px;
    }

    &:hover {
      background-color: ${({ theme }) => theme.backgroundLighter};
      width: 69px;
      height: 38px;

      &:before {
        border-top-color: ${({ theme }) => theme.backgroundLighter};
      }
    }

    &:before {
      position: absolute;
      right: 50%;
      bottom: -8px;
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      z-index: 50;
      border-color: rgba(0, 0, 0, 0);
      border-width: 8px 8px 0 8px;
      border-top-color: ${({ theme }) => theme.background};
      margin-right: -8px;
    }
  }

  .google-map-marker-favourite {
    filter: ${platform.select(
      'invert(39%) sepia(72%) saturate(4668%) hue-rotate(4deg) brightness(96%) contrast(101%)',
      'invert(44%) sepia(62%) saturate(3918%) hue-rotate(314deg) brightness(94%) contrast(98%)',
    )};
  }

  .google-map-marker.google-map-marker-clicked {
    background-color: ${({ theme }) => theme.backgroundLight};

    &:before {
      border-top-color: ${({ theme }) => theme.backgroundLight};
    }
  }

  .google-map-marker.google-map-marker-active {
    background-color: ${({ theme }) => theme.textDark};
    color: ${({ theme }) => theme.background};
    width: 69px;
    height: 38px;

    &:before {
      border-top-color: ${({ theme }) => theme.textDark};
    }

    img {
      filter: brightness(0) invert(1);
    }
  }

  .google-map-marker-compact {
    width: 50px;

    &:hover,
    &.google-map-marker-active {
      width: 54px;
    }
  }

  .important-place-pill {
    width: fit-content;
    min-height: fit-content;
    background-color: #b191ff;
    top: -10px;
    left: 60%;
    font-size: 12px;
    padding: 0 4px;
    color: ${({ theme }) => theme.white};
    border-radius: 5px;
    line-height: 21.6px;
    white-space: nowrap;
    max-width: 208px;
    overflow: hidden;
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
    font-weight: 600;
    position: absolute;
  }

  .important-place-pill-searched {
    background-color: ${({ theme }) => theme.green};
  }
`;

export default MapContainer;
